import { render, staticRenderFns } from "./TicketClipboardRouting.vue?vue&type=template&id=7354bba4&"
import script from "./TicketClipboardRouting.vue?vue&type=script&lang=js&"
export * from "./TicketClipboardRouting.vue?vue&type=script&lang=js&"
import style0 from "./TicketClipboardRouting.vue?vue&type=style&index=0&id=7354bba4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports